const BASE_URL = process.env.REACT_APP_API_URL ?? '';

export const getTournaments = async (pageIndex, pageSize) => {
  const url = new URL('/api/tournaments', BASE_URL || window.location.origin);
  url.searchParams.set('page', `${pageIndex}`);
  url.searchParams.set('pageSize', `${pageSize}`);
  const response = await fetch(url.href);
  return response.json();
};

export const getTournament = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}`);
  return response.json();
};

export const getTournamentPlayers = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/players`);
  return response.json();
};

export const getTournamentTeams = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/teams`);
  return response.json();
};

export const getTournamentRounds = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/rounds`);
  return response.json();
};

export const getTeamsTournamentRounds = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/teams-rounds`);
  return response.json();
};

export const saveTournament = async (tournamentData) => {
  const response = await fetch(`${BASE_URL}/api/tournament`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(tournamentData),
  });
  return response.json();
};

export const searchPlayers = async (query, excludeTorId) => {
  const url = new URL('/api/players/search', BASE_URL || window.location.origin);
  url.searchParams.set('q', query || '');
  if (excludeTorId) {
    url.searchParams.set('excludeTorId', `${excludeTorId}`);
  }
  const response = await fetch(url.href);
  return response.json();
};

export const enrollPlayer = async (torId, jugId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/player`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ jugId }),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al inscribir al jugador.');
  }
  return response.json();
};

export const quickRegisterAndEnrollPlayer = async (torId, playerData) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/player/quick-register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(playerData),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al registrar e inscribir al nuevo jugador.');
  }
  return response.json();
};

export const unenrollPlayer = async (torId, jugId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/player/${jugId}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error('Error al desinscribir al jugador');
  }
  return { success: true };
};

export const createTeam = async (torId, nombre) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/team`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ nombre }),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al crear el equipo.');
  }
  return response.json();
};

export const deleteTeam = async (torId, equId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/team/${equId}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error('Error al eliminar el equipo.');
  }
  return { success: true };
};

export const enrollPlayerInTeam = async (torId, equId, jugId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/team/${equId}/player`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ jugId }),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al inscribir al jugador en el equipo.');
  }
  return response.json();
};

export const quickRegisterAndEnrollInTeam = async (torId, equId, playerData) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/team/${equId}/player/quick-register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(playerData),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al registrar e inscribir al nuevo jugador.');
  }
  return response.json();
};

export const unenrollPlayerFromTeam = async (torId, equId, jugId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/team/${equId}/player/${jugId}`, {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error('Error al desvincular al jugador del equipo.');
  }
  return { success: true };
};

export const reorderTeamPlayers = async (torId, equId, playerIds) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/team/${equId}/player/reorder`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ playerIds }),
  });
  if (!response.ok) {
    throw new Error('Error al reordenar los tableros de los jugadores.');
  }
  return { success: true };
};

export const getRoundsMatches = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/rounds-matches`);
  if (!response.ok) {
    throw new Error('Error al obtener rondas y partidas.');
  }
  return response.json();
};

export const saveRoundsMatches = async (torId, data) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/rounds-matches`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al guardar rondas y partidas.');
  }
  return response.json();
};

export const saveTeamsRoundsMatches = async (torId, data) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/teams-rounds-matches`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al guardar los enfrentamientos y partidas de equipos.');
  }
  return response.json();
};

export const getTiebreakTypes = async (tipoTorneo) => {
  const url = new URL('/api/tiebreak-types', BASE_URL || window.location.origin);
  if (tipoTorneo !== undefined) {
    url.searchParams.set('tipoTorneo', `${tipoTorneo}`);
  }
  const response = await fetch(url.href);
  if (!response.ok) {
    throw new Error('Error al obtener los tipos de desempate.');
  }
  return response.json();
};

export const getTournamentTiebreaks = async (torId) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/tiebreaks`);
  if (!response.ok) {
    throw new Error('Error al obtener los desempates configurados para el torneo.');
  }
  return response.json();
};

export const calculateStandings = async (torId, tiebreaks) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/calculate-standings`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ tiebreaks }),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al calcular la clasificación.');
  }
  return response.json();
};

export const saveStandings = async (torId, data) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/save-standings`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data), // { positions, tiebreaks }
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al guardar la clasificación.');
  }
  return response.json();
};

export const calculateTeamsStandings = async (torId, tiebreaks) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/calculate-teams-standings`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ tiebreaks }),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al calcular la clasificación por equipos.');
  }
  return response.json();
};

export const saveTeamsStandings = async (torId, data) => {
  const response = await fetch(`${BASE_URL}/api/tournament/${torId}/save-teams-standings`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data), // { positions: [{equipoId, posicionFinal, puntajeFinal}], tiebreaks }
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al guardar la clasificación de equipos.');
  }
  return response.json();
};

